import { gql } from "@apollo/client";export default gql`mutation InsertBatchCollection($objects: [collection_insert_input!]!) {
  insert_collection(objects: $objects) {
    affected_rows
  }
}
`;
